function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M0 396.254C919.5 698.5 1435-464.5 2337 220.842V844H0V396.254z",
  fill: "url(#contact-backdrop_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 412.807C924.5 690.035 1406-346 2337 243.879V844H0V412.807z",
  fill: "url(#contact-backdrop_svg__paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "contact-backdrop_svg__paint0_linear",
  x1: 1168.5,
  y1: 844,
  x2: 1168.5,
  y2: 0.897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42B189"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81DB62"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "contact-backdrop_svg__paint1_linear",
  x1: 1168.5,
  y1: 844,
  x2: 1168.5,
  y2: 59.129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42B189"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81DB62"
})));

function SvgContactBackdrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 2337 844",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMjMzNyA4NDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZD0iTS0zLjkxNDMyZS0wNSAzOTYuMjU0QzkxOS41IDY5OC41IDE0MzUgLTQ2NC41IDIzMzcgMjIwLjg0MkwyMzM3IDg0NEwwIDg0NEwtMy45MTQzMmUtMDUgMzk2LjI1NFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggZD0iTS0zLjc2OTYxZS0wNSA0MTIuODA3QzkyNC41IDY5MC4wMzUgMTQwNiAtMzQ2IDIzMzcgMjQzLjg3OUwyMzM3IDg0NEwwIDg0NEwtMy43Njk2MWUtMDUgNDEyLjgwN1oiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjExNjguNSIgeTE9Ijg0NCIgeDI9IjExNjguNSIgeTI9IjAuODk2NjQ4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM0MkIxODkiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODFEQjYyIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhciIgeDE9IjExNjguNSIgeTE9Ijg0NCIgeDI9IjExNjguNSIgeTI9IjU5LjEyOTEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzQyQjE4OSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM4MURCNjIiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgContactBackdrop as ReactComponent };